import get from 'lodash.get';

const getEmptyPageIgnoredBlocks = (rootState) =>
  get(rootState, 'ws.template.meta.emptyPage.ignoredBlocks', []);

export default getEmptyPageIgnoredBlocks;
